import { cssBundleHref } from '@remix-run/css-bundle';

import {
  Links,
  LiveReload,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration } from
'@remix-run/react';

import { captureRemixErrorBoundaryError, withSentry } from '@sentry/remix';

import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css?__remix_sideEffect__";

import stylesheet from '~/tailwind.css';
import GlobalNotificationTray from './components/NotificationTray/GlobalNotificationTray';

export function ErrorBoundary({ error }) {
  captureRemixErrorBoundaryError(error);
  return (
    <div className="container mx-auto flex h-full w-full items-center justify-center bg-destructive p-20 text-h2 text-destructive-foreground">
      <p>
        {error.status} {error.data}
      </p>
    </div>);

}

export const links = () => [
...(cssBundleHref ? [{ rel: 'stylesheet', href: cssBundleHref }] : []),
{ rel: 'stylesheet', href: stylesheet },
{
  rel: 'icon',
  href: '/favicon.png',
  type: 'image/png'
},
{
  rel: 'apple-touch-icon',
  href: '/favicon.png',
  type: 'image/png'
},
{
  rel: 'mask-icon',
  href: '/favicon.svg',
  color: '#000000'
},
{
  rel: 'preconnect',
  href: 'https://use.typekit.net/ylb1xoy.css',
  crossOrigin: 'true'
}];


function App() {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="stylesheet" href="https://use.typekit.net/ylb1xoy.css" />
        <Meta />
        <Links />
      </head>
      <body>
        <Outlet />
        <ToastContainer />
        {/* <GlobalNotificationTray /> */}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>);

}

export default withSentry(App);